import {v4} from 'uuid';

/**
 * Data object representing the expert report types list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class ExpertReportTypesListItemDataObject {
	/**
	 * @param {string} id - DB ID of the expert report type.
	 * @param {string} name - Name of the expert report type.
	 */
	constructor(id, name) {
		this.id = id;
		this.name = name;
	}
}

/**
 * Data object representing the expert report types item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class ExpertReportTypesItemDataObject {
	/**
	 * @param {string|null} [id=null] - Item's ID.
	 * @param {string} [name=''] - Item's name.
	 * @param {string} [content=''] - Content section text of the expert report type.
	 * @param {?string} [templateFileId=null] - DB ID of the uploaded template file.
	 * @param {string} [templateFileName=''] - Name of the uploaded template file.
	 * @param {?ExpertReportTypeSectionDataObject[]} [sections=[]] - List of additional content sections of the expert 
	 * report type.
	 */
	constructor(id = null, name = '', content = '', templateFileId = null, templateFileName = '', sections = []) {
		this.id = id;
		this.name = name;
		this.content = content;
		this.templateFileId = templateFileId;
		this.templateFileName = templateFileName;
		this.sections = sections;
	}
}

/**
 * Data object representing the expert report type's additional content section
 */
export class ExpertReportTypeSectionDataObject {
	/**
	 * @param {?string} [id=null] - ID of the expert report additional content section.
	 * @param {string} [name=''] - Name of the expert report additional content section.
	 * @param {string} [defaultText=''] - Default content of the expert report additional content section.
	 * @param {number} [ordinal=0] - Ordinal number of the expert report additional content section.
	 * @param {string} [GUIID=v4()] - Unique ID of the expert report additional content section.
	 */
	constructor(id = null, name = '', defaultText = '', ordinal = 0, GUIID = v4()) {
		this.id = id;
		this.name = name;
		this.defaultText = defaultText;
		this.ordinal = ordinal;
		
		this.GUIID = GUIID;
	}
}
